import { combineReducers } from "redux";
import { complaints } from './complaints/reducer';
import { posts } from './posts/reducer';
import { users } from "./users/reducer";

const rootReducer = combineReducers({
  posts,
  complaints,  
  users,
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
